/**
 * LogoBar Organism Component
 * Row of client logos with even spacing
 */

import React from 'react';
import { storyblokEditable } from '@/lib/blocks';
import { Container } from '@/components/atoms/Container';
import { ClientLogo } from '@/components/molecules/ClientLogo';
import type { LogoBarBlok } from '@/types';

export interface LogoBarProps {
  blok: LogoBarBlok;
}

export const LogoBar: React.FC<LogoBarProps> = ({ blok }) => {
  const { logos } = blok;

  if (!logos || logos.length === 0) return null;

  return (
    <section
      {...storyblokEditable(blok)}
      className="py-8 md:py-12 lg:py-16 bg-theme-bg"
    >
      <Container>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
          {logos.map((logo) => (
            <ClientLogo key={logo._uid} blok={logo} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default LogoBar;
